import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 250px;
  width: 320px;
  border-radius: 5px;
  padding: 4px;
  gap: 10px;
  background-color: #7a7a7a5e;
`;
export const SideBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px;
  height: 100%;
  gap: 5px;

  .info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .tree {
    margin-top: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
`;
export const Post = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  .header {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .postInfo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }

  .contentPost {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 3px;
  }
`;
export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;
export const PostFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
`;